
import React from 'react'; // Removed useState
import { IndustrySection } from '../../../addBusinessModal';
import { FormSection } from '../';
import { industryOptions } from '../../../addBusinessModal/constants';
import { useBusinessFormContext } from '@/context/BusinessFormContext';

interface IndustryFormSectionProps {}

const IndustryFormSection: React.FC<IndustryFormSectionProps> = () => {
  const {
    businessDetails,
    handleSelectChange,
    industryOpen,
    setIndustryOpen,
    industryComplete,
    industryEdited,
    industryHasChanges,
    saveIndustry, // Use context's saveIndustry directly
    isSavingIndustry, // Use context's loading state
  } = useBusinessFormContext();

  // Local isProcessing state and handleSave wrapper are no longer needed.

  return (
    <FormSection
      number={3}
      title="Industry"
      open={industryOpen}
      onOpenChange={setIndustryOpen}
      isCompleted={industryEdited}
      isDisabled={false}
      isComplete={industryComplete}
      isEdited={industryEdited}
      hasUnsavedChanges={industryHasChanges}
      onSave={saveIndustry} // Pass context's saveIndustry directly
      isProcessing={isSavingIndustry} // Pass context's loading state
    >
      <IndustrySection
        businessDetails={businessDetails}
        handleSelectChange={handleSelectChange}
        industryOptions={industryOptions}
        onSaveIndustry={saveIndustry} // Pass context's saveIndustry
        industryComplete={industryComplete}
      />
    </FormSection>
  );
};

export default IndustryFormSection;
